import { jwtDecode } from 'jwt-decode'
const jwtDecoder = (jwt) => {
  return jwtDecode(jwt)
}

export default jwtDecoder
